import React, { lazy, Suspense } from "react";
import { ProSidebarProvider } from "react-pro-sidebar";
const Header = lazy(() =>
  import("./header/header" /*webpackChunkName:"header"*/)
);
const Aside = lazy(() => import("./aside/aside" /*webpackChunkName:"aside"*/));

export default function Layout({ children }) {
  return (
    <ProSidebarProvider>
      <main className="main">
        <Suspense fallback={<></>}>
          <Header />
        </Suspense>
        <div className="dir-rtl">
          <div className="aside-holder">
            <Suspense fallback={<></>}>
              <Aside />
            </Suspense>
          </div>
          <main role="main" class="flex-shrink-0 admin-main-body">
            <div className="admin-body">{children}</div>
          </main>
        </div>
      </main>
    </ProSidebarProvider>
  );
}
